/**
* Looks up the default language of the browser, as 2-letter lowercase string.
* If the language cannot be loaded, returns undefined.
*/
export function getSystemLanguage () {
  if (!window || !window.navigator) {
    return
  }

  var code = window.navigator.userLanguage || window.navigator.language
  if (!code) {
    return
  }

  if (code.length > 2) {
    code = code.substring(0, 2)
  }

  return code.toLowerCase()
}

// Creates a userData object (a simple JS object with keys for all user/address
// props) from a Parse User object and a Parse Address object.
export function createUserData (parseUser, parseAddress) {
  const user = parseUser.toJSON()
  const address = parseAddress ? parseAddress.toJSON() : {}

  const { email, firstName, lastName, phone, language } = user
  const { countryCode, zipCode, city, street, streetNumber } = address

  return { id: parseUser.id, email, firstName, lastName, phone, language, country: countryCode, zip: zipCode, city, street, streetNumber }
}



// WEBPACK FOOTER //
// ./src/helpers/utils.js